import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {getDefaultLandingPath} from '@/utils/defaultLandingPath';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const isLoginPage = location.pathname === '/login';

  // 白名单路径，不需要token验证
  const whitelistPaths = ['/login', '/face'];
  const isWhitelistPath = whitelistPaths.includes(location.pathname);

  // 如果已登录且访问登录页，按角色重定向到默认页
  if (isLoginPage && token) {
    return <Navigate to={getDefaultLandingPath()} replace />;
  }

  // 如果是白名单路径，直接渲染
  if (isWhitelistPath) {
    return <>{children}</>;
  }

  // 如果未登录且不是白名单路径，重定向到登录页
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 其他情况正常渲染
  return <>{children}</>;
};

export default PrivateRoute;
